import { Injectable } from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { WorkspaceEditorComponent } from "./workspace-editor/workspace-editor.component";

@Injectable({ providedIn: "root" })
export class WorkspaceService {
  constructor(private dialog: MatDialog) {}

  newWorkspace() {
    this.dialog.open(WorkspaceEditorComponent);
  }
}
